import React, { useState } from "react";
import { FaComments, FaPhoneAlt } from "react-icons/fa";
import ChatDrawer from "./ChatDrawer";

function ChatButton({ uid }) {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <>
      <button
        className="btn connect-btn "
        onClick={() => setChatOpen(true)}
      >
        <FaComments size={25} className="me-1" />   Message
      </button>

      <ChatDrawer
        uid={uid}
        show={chatOpen}
        onClose={() => setChatOpen(false)}
      />
    </>
  );
}

export default ChatButton;
